import { defineComponent as I, computed as m, createElementBlock as p, openBlock as n, normalizeClass as M, unref as a, createBlock as i, createCommentVNode as v, Fragment as f, renderList as j } from "vue";
import { useColorMode as V } from "@scalar/use-hooks/useColorMode";
import { useMediaQuery as E } from "@vueuse/core";
import { useRoute as S } from "vue-router";
import { DocumentClasses as _ } from "../../styles.js";
import H from "./HeaderItemGroup.vue.js";
import N from "./HeaderItemLink.vue.js";
import w from "./HeaderItemMeta.vue.js";
import C from "./HeaderItemSpacer.vue.js";
import $ from "./HeaderItemTab.vue.js";
import B from "./HeaderItemVersionSelect.vue.js";
const J = /* @__PURE__ */ I({
  __name: "DocumentHeader",
  props: {
    project: {},
    versions: {},
    activeVersion: {},
    activeUids: {},
    activeGuide: {},
    headerLinks: {},
    isEditable: { type: Boolean },
    resolveInternalLinks: { type: Function }
  },
  emits: ["selectVersion", "navigate", "setSidebar", "toggleShow"],
  setup(g, { emit: k }) {
    const t = g, l = k, d = S(), { isDarkMode: y } = V(), b = m(() => y.value ? t.project.logo.darkMode : t.project.logo.lightMode), s = E("(max-width: 1000px)"), h = m(() => {
      const e = [...t.headerLinks];
      return s.value ? e.sort((o) => o.type === "version-selector" ? -1 : 1).filter((o) => o.type !== "spacer") : e;
    });
    function u(e, o) {
      l("navigate", o, e), s.value && l("setSidebar", !1);
    }
    function L(e, o) {
      l("toggleShow", e, o);
    }
    function c(e) {
      var o;
      return (o = t.activeUids) != null && o.includes(e.uid) || e.uid === d.name || e.uid === t.activeGuide || Object.values(d.params).includes(e.uid) ? !0 : e.type === "group" ? e.children.some((r) => c(r)) : !1;
    }
    return (e, o) => (n(), p("header", {
      class: M(["header", a(_).Header])
    }, [
      a(s) ? v("", !0) : (n(), i(w, {
        key: 0,
        logo: b.value,
        primaryVersionUid: e.project.activeVersionId,
        projectName: e.project.name
      }, null, 8, ["logo", "primaryVersionUid", "projectName"])),
      (n(!0), p(f, null, j(h.value, (r) => (n(), p(f, {
        key: r.uid
      }, [
        r.type === "group" ? (n(), i(H, {
          key: 0,
          group: r,
          isEditable: !!e.isEditable,
          isMobile: a(s),
          linkIsActive: c,
          resolveInternalLinks: e.resolveInternalLinks,
          onNavigate: u
        }, null, 8, ["group", "isEditable", "isMobile", "resolveInternalLinks"])) : r.type === "guide" || r.type === "reference" ? (n(), i($, {
          key: 1,
          isEditable: !!e.isEditable,
          isMobile: a(s),
          linkIsActive: c,
          resolveInternalLinks: e.resolveInternalLinks,
          tab: r,
          onNavigate: u,
          onToggleShow: L
        }, null, 8, ["isEditable", "isMobile", "resolveInternalLinks", "tab"])) : r.type === "link" ? (n(), i(N, {
          key: 2,
          link: r
        }, null, 8, ["link"])) : r.type === "spacer" ? (n(), i(C, { key: 3 })) : r.type === "version-selector" && Object.keys(e.versions).length > 1 ? (n(), i(B, {
          key: 4,
          activeVersion: e.activeVersion,
          versions: e.versions,
          onNavigate: u
        }, null, 8, ["activeVersion", "versions"])) : v("", !0)
      ], 64))), 128))
    ], 2));
  }
});
export {
  J as default
};
